import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAccountWalletImage } from "../../hooks/useAccountWallet.js";
import { IPFSMediaRenderer } from "../IPFSMediaRenderer/IPFSMediaRenderer.js";
const WalletImage = t0 => {
  const $ = _c(2);
  const {
    fallback
  } = t0;
  const walletImage = useAccountWalletImage();
  if (walletImage) {
    let t1;
    if ($[0] !== walletImage) {
      t1 = _jsx(IPFSMediaRenderer, {
        src: walletImage,
        alt: "Profile",
        className: "h-6 w-6 rounded-full"
      });
      $[0] = walletImage;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  return fallback || null;
};
export default WalletImage;